import { Control, ControlInlined } from "../control/control.model";
import { createSelector } from "reselect";
import { Job } from "./job.model";
import { Form, FormInlined } from "./form.model";
import { Group, GroupInlined } from "../group/group.model";
import { RestrictedAccountObjectQueryFactory } from "../restricted-account-object/restricted-account-object.query-factory";
import { listSelector } from "../query-facade";
import { BaseObjectFilters } from "../../store/bootstrap";
import { VasState } from "../../store/store-type";
import { ControlType } from "../control-type/control-type.model";

export class FormQueryFactory extends RestrictedAccountObjectQueryFactory<Form, BaseObjectFilters> {

    protected _inlined: listSelector<FormInlined>;
    protected _byActiveAccountInlined: listSelector<FormInlined>;

    get inlined(): listSelector<FormInlined> {

        if (!this._inlined) {

            this._inlined = createSelector(
                this.items,
                this.groupEntities,
                this.controlEntities,
                this.controlTypeEntities,
                (forms, groups, controls, controlTypes) => {
                    return forms.map(form => new FormInlined({
                        ...form,
                        groups: form.groups
                            .map(groupId => groups[groupId])
                            .sort((a, b) => a.sequence - b.sequence)
                            .map((group: Group) => {
                                return new GroupInlined({
                                    ...group,
                                    controls: !group ? [] : (group.controls as Array<string>)
                                        .map(controlId => controls[controlId])
                                        .filter(control => !!control)
                                        .map((control: Control) => {
                                            return new ControlInlined({
                                                ...control,
                                                controlType: controlTypes[control.controlType]
                                            });
                                        })
                                        .sort((a, b) => a.sequence - b.sequence)
                                });
                            })
                    }));
                }
            );
        }

        return this._inlined;
    }

    get byActiveAccountInlined(): listSelector<FormInlined> {

        if (!this._byActiveAccountInlined) {

            this._byActiveAccountInlined = createSelector(this.inlined, this.selectedAccountId,
                (items, accountId) => {
                    if (!accountId) return [];
                    return items.filter(item => item.account === accountId);
                });

        }

        return this._byActiveAccountInlined;
    }

    protected groupEntities(state: VasState): { [id: string]: Group } {
        return state.group.entities;
    }

    protected controlEntities(state: VasState): { [id: string]: Control } {
        return state.control.entities;
    }

    protected controlTypeEntities(state: VasState): { [id: string]: ControlType } {
        return state.controlType.entities;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/form/form.queries.ts